<!-- src/app/shared/components/search-bar/search-bar.component.html -->
<div class="search-bar">
  <input
    type="text"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [(ngModel)]="internalValue"
    (ngModelChange)="onInputChange($event)" />

  <button
    *ngIf="internalValue"
    type="button"
    class="clear-btn"
    (click)="clear()"
    [disabled]="disabled"
    aria-label="Clear search">
    ×
  </button>
</div>